import script from "./NewNotice.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewNotice.vue?vue&type=script&lang=ts&setup=true"

import "./NewNotice.vue?vue&type=style&index=0&id=378ade0a&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378ade0a"]])

export default __exports__